














































import {Component, Vue} from 'vue-property-decorator';
import Renderer from '@/logic/renderer';
import World from '@/logic/world';
import Rules from '@/logic/rules';
import Presets from '@/logic/presets';
import Timer from '@/logic/timer';
import ClipboardJS from 'clipboard';

@Component
export default class Graphics extends Vue
{
    renderer: Renderer;
    world: World;
    timer: Timer = null as unknown as Timer;

    inputDelay: number = 100;
    saveLoadText: string = '';
    saveLoadShow: boolean = false;

    /**
     * This is called when the page finishes loading
     */
    mounted()
    {
        // Find canvas and create renderer
        let nullableCanvas = document.querySelector('#world-canvas');
        if (nullableCanvas == null) return;
        let canvas: any = nullableCanvas;
        this.renderer = new Renderer(canvas);

        // Set frame
        this.renderer.setFrame(1000, 500);

        // Draw grid
        this.renderer.drawGrid();

        // Create world
        this.world = new World(
        {
            name: 'Test',
            width: 1000 / 5,
            height: 500 / 5,
            rules: Rules.conway,
            presetCells: new Presets({x: 1000 / 5 / 2, y: 500 / 5 / 2}).CELLULAR_AUTOMATA,
            onUpdate: cell => this.renderer.drawCell(cell)
        });

        // Create timer
        this.timer = new Timer(() => this.world.act(), this.inputDelay);

        //Register copy/paste button
        new ClipboardJS('.btn');

        // Set click listener
        canvas.addEventListener('click', (event: any) =>
        {
            let x = event.pageX - canvas.offsetLeft;
            let y = event.pageY - canvas.offsetTop;

            console.log(x + ', ' + y);

            // Get the current state of the cell
            //@ts-ignore
            let point = {x: Math.floor(x / 5 / canvas.offsetWidth * 1000), y: Math.floor(y / 5 / canvas.offsetHeight * 500)};
            let cell = this.world.getCell(point);
            this.world.setCellStatus(point, {alive: !cell.status.alive});
            this.world.activePoints.push(point);
        });
    }

    /**
     * This is called when the update button is clicked
     */
    updateButton()
    {
        this.world.act()
    }

    toggle()
    {
        this.timer.toggle();
    }

    frameDelayTextbox()
    {
        this.timer.setDelay(this.inputDelay)
    }

    clearScreen()
    {
        this.world.clearGrid();
    }

    saveLoad()
    {
        this.saveLoadShow = true;
        this.saveLoadText = this.world.serializeWorld();
    }

    load()
    {
        this.world.loadWorld(this.saveLoadText);
    }
}
